import React, { Fragment } from 'react';
import { createForm } from 'rc-form';
import qs from 'query-string';
import { Button, Toast, InputItem, Picker, List, Modal } from 'antd-mobile';
import { withRouter, RouteComponentProps } from 'react-router';
import connect from '../store/connect';

import PageLoading from '../components/page-loading';
import QuestionnaireItem from '../components/questionnaire/questionnaire-item';
import CommitForm from '../components/commit-form';
import SoldOut from '../components/activity/sold-out';
import CopyRight from '../components/copy-right';
import LeaveDialog from '../components/dialog/dialog';
import ProtocolCheck from '../components/protocol/check';

import { answerQustions, queryAnswersByXfieldOrActId, saveXjtgInfo, getClueOwnerByProjectId } from '../service/api';
import { setDocumentTitle } from '../utils';
import { defaultLayerUrl } from '../utils/constant';
import { isVerifyCode, isAreaPhone } from '../utils/verify';
import { sendVerifyCode, getCountryCodeList, diffEnvLoginByVerify } from '../service/login';
import { formatAnswerObj, getSurveyInfo, getVerifyRoles } from '../service/SurveyService';
import { sensorsTrack } from '../service/sensors';
import HeartBeat from '../service/wecomService';
import { wxShareCfg } from '../service/wxConfig';

import '../assets/css/questionnaire-list.less';
import SchemaRender from '../components/SchemaRender';
import moment from 'moment';
import { GdImage } from '@gaodun.com/gui-pc';
import EasyChatIframe from '../components/easy-chat-iframe';

class Questionnaire extends React.Component<Props & RouteComponentProps, State> {
    private timer: any;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            bottomBanner: '',
            bottomBannerLink: '',
            topBanner: '',
            topBannerLink: '',
            questionInfo: {},
            questionList: [],
            submitLoading: false,
            answersObj: {},
            expired: false,
            countryCodeList: [],
            areaCode: ['86'],
            phone: '',
            verify: '',
            countdown: 0,
            hassend: false,
            showLeaveDialog: false,
            isDetainDialogShow: true,
            hasSubmit: 0,
            layerUrl: '',
            hadAnswer: false,
            hadAnswerTips: false,
            tipsTimerCount: 3,
            pagingDisplay: 1,
            checked: false,
            productInfo: {},
            isShowRepeatBuy: false,
            weChatUrl: '',
        };
    }
    tipsTimer?: number;
    senderTimer?: number;
    search: any = qs.parse(this.props.location.search);
    questionInfo: any;
    _body: any = document.querySelector('body');
    checkEle?: ProtocolCheck;
    heartbeat?: HeartBeat;
    enterTime?: any;

    componentDidMount(): void {
        this.enterTime = moment()
    }

    componentWillMount() {
        getCountryCodeList().then(list => {
            this.setState({
                countryCodeList: list,
            });
        });
        this.getQuestinoList();
        if (this._body) this._body.className = 'questionnaire-page';
    }

    componentWillUnmount() {
        if (this._body) this._body.className = '';
        if (window.history && !this.state.hasSubmit) {
            window.removeEventListener('popstate', this.HistoryHandler.bind(this));
        }
        this.setState = (state, callback) => {
            return;
        };
        this.heartbeat && this.heartbeat.destory();
    }

    HistoryHandler(): void {
        if (this.state.isDetainDialogShow) {
            this.timer = setTimeout(() => {
                this.setState({
                    showLeaveDialog: true,
                    isDetainDialogShow: false,
                });
            }, 0);
        }
    }

    dialogStatusChange = (status: Boolean, callback: any) => {
        this.setState({
            showLeaveDialog: status,
        });
    };

    // 初始化表单数据，在新模版中使用
    async initData() {
        try {
            let { x_field_1, surveyActivityId, isAPP } = this.search;
            let params = surveyActivityId ? { activityId: surveyActivityId } : { x_field: x_field_1 };
            let activityInfo;
            activityInfo = await getSurveyInfo(params);
            this.setState({
                productInfo: activityInfo,
            });
        } catch (error) {
            
        }
    }

    async getQuestinoList() {
        let { x_field_1, surveyActivityId, isAPP } = this.search;
        let params = surveyActivityId ? { activityId: surveyActivityId } : { x_field: x_field_1 };
        let activityInfo;
        try {
            activityInfo = await getSurveyInfo(params);
        } catch (error) {}
        if (!!activityInfo) {
            const { activity, mktActivityShowAndShareConfigs, layerUrl, survey } = activityInfo;
            const { isDelete, bottomBanner, bottomBannerLink, topBanner, topBannerLink, name, activityStatus, showConfigExt } = activity;

            this.questionInfo = activity;
            sensorsTrack('SCRM_activitydetail__view', {
                scrm_xField: x_field_1 || '',
                scrm_activity_way: activity.activityWay,
                scrm_activity_name: activity.name,
                scrm_activity_id: activity.id,
                scrm_plan_name: activity.planName,
                scrm_plan_id: activity.planId,
                ...(isAPP == '1' ? { app_source: 1 } : undefined),
            });
            if (this.search.UID && this.search.contentId) {
                this.heartbeat = new HeartBeat({
                    active_page_id: this.search.contentId,
                    active_page_name: activity.name,
                    staff_id: this.search.UID,
                    source:this.search?.source,
                    type: 33,
                });
                this.heartbeat.start();
            }
            this.setState(
                {
                    bottomBanner,
                    bottomBannerLink,
                    topBanner,
                    topBannerLink,
                    questionInfo: activity,
                    questionList: survey.questionList,
                    layerUrl: layerUrl,
                    expired: !activityStatus || isDelete,
                    pagingDisplay: activity.pagingDisplay,
                    checked: !!showConfigExt && !!JSON.parse(showConfigExt).protocolStatus,
                    productInfo: activityInfo,
                },
                () => {
                    // 添加一条新的空历史记录，以便监听popstate事件显示挽留层
                    if (window.history) {
                        if (!this.state.hasSubmit && mktActivityShowAndShareConfigs && !mktActivityShowAndShareConfigs.layerStatus) {
                            window.history.pushState('back', '', '');
                            window.addEventListener('popstate', this.HistoryHandler.bind(this));
                        }
                    } else {
                        throw new Error('您的浏览器版本过低，请升级您的浏览器');
                    }
                }
            );
            let { accessToken, needPhoneBind } = this.props.loginStatus;
            // 若是登录状态 && 未过期
            if (accessToken && !needPhoneBind && !!activityStatus && !isDelete) {
                // 获取答题信息
                this.getQuestionAnswers();
            } else {
                this.setState({
                    loading: false,
                });
            }
            setDocumentTitle(survey.displayName);
            wxShareCfg(
                name,
                window.location.href,
                mktActivityShowAndShareConfigs.sharePicture,
                mktActivityShowAndShareConfigs.shareDescription
            );
        } else {
            this.setState({
                loading: false,
            });
            Toast.show('获取问卷信息失败');
        }
    }

    /**
     * 获取用户答题记录，若已提交显示‘您已提交’弹层
     */
    getQuestionAnswers = async () => {
        let { x_field_1, surveyActivityId } = this.search;
        let params = surveyActivityId ? { activityId: surveyActivityId } : { x_field: x_field_1 };

        // 获取答题信息
        let questionAnswersRes = await queryAnswersByXfieldOrActId(params);
        if (!questionAnswersRes.status && !!questionAnswersRes.result) {
            let { questionAnswerList, isAnswer } = questionAnswersRes.result;
            let [answersObj, hadAnswer] = formatAnswerObj(questionAnswerList);
            await this.setState(
                {
                    loading: false,
                    answersObj,
                    hadAnswer: !!isAnswer ? isAnswer : hadAnswer,
                },
                () => {
                    if (this.state.hadAnswer) {
                        this.props.form.setFieldsValue(answersObj);
                        this.handleTipsHadAnswer();
                    }
                }
            );
        }
    };

    startCountDown = () => {
        this.setState({
            countdown: 60,
            hassend: true,
        });
        this.senderTimer = window.setInterval(() => {
            let { countdown } = this.state;
            if (countdown > 0) {
                this.setState({
                    countdown: countdown - 1,
                });
            } else {
                this.setState({
                    countdown: 0,
                });
                window.clearInterval(this.senderTimer);
            }
        }, 1000);
    };
    handleSendVerifyCode = () => {
        let { countdown, phone, areaCode } = this.state;
        let { sourceType, promotionUserId, mcrmActivityTypeStr, promotionUserType, mkey } = this.search;
        // countdown 为零可以发送
        if (!countdown) {
            // 如果手机号有误
            if (!phone || !isAreaPhone(phone, areaCode[0])) {
                Toast.show('请输入正确手机号', 3, false);
                return;
            }
            let where = {
                previewActionType: 'SURVEY',
                projectId: this.questionInfo.projectId,
                promotionUserId: !!promotionUserId && promotionUserId != 'null' ? parseInt(promotionUserId) : null,
                landingPageId: this.questionInfo.id,
                sourceType: !!sourceType ? sourceType : 'scrm',
                surveyName: !!this.questionInfo.survey ? this.questionInfo.survey.name : '',
                mcrmActivityTypeStr: !!mcrmActivityTypeStr ? mcrmActivityTypeStr : null,
                promotionUserType: !!promotionUserType && promotionUserType != 'null' ? promotionUserType : null,
                mkey,
            };
            sendVerifyCode(phone, areaCode[0], where)
                .then(msg => {
                    Toast.show(msg, 1.5, false);
                    this.startCountDown();
                })
                .catch(e => {
                    Toast.show(e, 3, false);
                });
        }
    };

    handleSave = async (val?: any) => {
        const { areaCode, phone, verify, pagingDisplay, checked } = this.state;
        const { accessToken, needPhoneBind } = this.props.loginStatus;

        // 未登录 || 需绑定手机号
        if (!accessToken || needPhoneBind) {
            if (!phone || !isAreaPhone(phone, areaCode[0])) {
                return Toast.show(`请输入${!!phone ? '正确的' : ''}手机号`, 3, false);
            }
            if (!verify || !isVerifyCode(verify)) {
                return Toast.show(`请输入${!!verify ? '正确的' : ''}验证码`, 3, false);
            }
        }
        if (!checked) {
            return this.checkEle && this.checkEle.shake();
        }
        this.props.form.validateFields(async (error: any, values: any) => {
            if (!error) {
                let { x_field_1, promotionUserId, promotionUserType, sourceType, mkey, isAPP, documentId, platform } = this.search;
                console.log(typeof platform, platform === 13607,  this.search.documentId);
                
                sensorsTrack('SCRM_activitydetail_buy_click', {
                    scrm_xField: x_field_1 || '',
                    scrm_activity_way: this.questionInfo.activityWay,
                    scrm_activity_name: this.questionInfo.name,
                    scrm_activity_id: this.questionInfo.id,
                    scrm_plan_name: this.questionInfo.planName,
                    scrm_plan_id: this.questionInfo.planId,
                    ...(isAPP == '1' ? { app_source: 1 } : undefined),
                });
                this.setState({
                    submitLoading: true,
                });

                // 未登录 --- 登录 -> 更新用户信息
                if (!accessToken || needPhoneBind) {
                    let area = areaCode[0] === '86' ? '' : areaCode[0];

                    try {
                        // 通过验证码登录
                        await diffEnvLoginByVerify(phone, area, verify, '');
                        // 更新用户信息
                        await this.props.updataUserLoginInfo();

                        // 获取问卷答案
                        await this.getQuestionAnswers();
                        // 若已答
                        if (this.state.hadAnswer) {
                            // 终止提交进程
                            return this.setState({
                                submitLoading: false,
                            });
                        }
                    } catch (error) {
                        this.setState({
                            submitLoading: false,
                        });
                        return Toast.fail(error, 3, undefined, false);
                    }
                }
                // 活动已结束
                if (this.questionInfo.activityState == '已结束') {
                    this.setState({
                        submitLoading: false,
                    });
                    // 提示已结束，终止提交进程
                    return Toast.fail('活动已结束', 3, undefined, false);
                }

                let answerList: any[] = [];
                let answerValue = pagingDisplay == 2 && !!window['browser'].mobile ? val : values;
                for (let i in answerValue) {
                    answerList.push({
                        questionName: i,
                        answer: answerValue[i],
                    });
                }
                const fillTime = moment().diff(this.enterTime, 'seconds');
                let params = {
                    ext: {
                        xField: x_field_1,
                        projectId: this.questionInfo.projectId,
                        activityId: this.questionInfo.id,
                        promotionUserId: !!promotionUserId && promotionUserId != 'null' ? parseInt(promotionUserId) : null,
                        landingPageId: this.questionInfo.id,
                        promotionUserType: !!promotionUserType && promotionUserType != 'null' ? promotionUserType : null,
                        mkey,
                        fillTime
                    },
                    activityWay: this.questionInfo.activityWay,
                    sourceType: !!sourceType ? sourceType : 'scrm',
                    surveyName: !!this.questionInfo.survey ? this.questionInfo.survey.name : '',
                    questionAnswerList: answerList,
                };
                let res = await answerQustions(params);
                // 小吉推广提交表单后，推送线索信息
                platform === '13607'  && await saveXjtgInfo({ documentId })
                if (!res.status) {
                    Toast.success('提交成功', 1.5, () => {
                        this.handleGointoSuccessPage();
                    });
                } else if (res.status == 1601100012) {
                    Toast.fail(res.info, 3, () => {
                        window.location.reload();
                    });
                } else if (res.status === 16013213) {
                   const data = await getClueOwnerByProjectId({
                        projectId: this.questionInfo.projectId,
                    });
                    if (data.status === 0 && data.result) {
                        this.setState({ isShowRepeatBuy: true, weChatUrl: data.result.weChatCode });
                    } else {
                        Toast.fail(res.info);
        
                    }
                } else {
                    Toast.fail(res.info);
                }
                this.setState({
                    submitLoading: false,
                });
            } else {
                Toast.show('请先完成问卷', 1.5, false);
            }
        });
    };
    handleHadAnswerTipsHide = () => {
        this.setState({
            hadAnswerTips: false,
        });
        window.clearTimeout(this.tipsTimer);
    };
    handleTipsHadAnswer = () => {
        this.setState(
            {
                hadAnswerTips: true,
            },
            () => {
                this.tipsTimer = window.setInterval(() => {
                    let { tipsTimerCount } = this.state;
                    if (tipsTimerCount > 0) {
                        this.setState({
                            tipsTimerCount: tipsTimerCount - 1,
                        });
                    } else {
                        this.handleHadAnswerTipsHide();
                        this.handleGointoSuccessPage();
                    }
                }, 1000);
            }
        );
    };
    handleGointoSuccessPage = () => {
        let { x_field_1, orderToken, promotionUserId, promotionUserType, sourceType, mkey, redirect } = this.search;
        let { id } = this.questionInfo;

        if (!!redirect) {
            window.location.href = redirect;
            return;
        }

        if (id && orderToken) {
            this.props.history.push(`/success/${orderToken}?progress=complete`);
        } else {
            this.props.history.push(
                qs.stringifyUrl({
                    url: '/qasuccess',
                    query: {
                        surveyActivityId: id,
                        x_field_1,
                        sourceType,
                        promotionUserId,
                        promotionUserType,
                        mkey,
                    },
                })
            );
        }
    };


    closeRepeat = () => {
        this.setState({
            isShowRepeatBuy: false,
        });
    };

    render() {
        const { x_field_1 } = this.search;
        const { accessToken, needPhoneBind, userInfo } = this.props.loginStatus;
        const { getFieldDecorator, getFieldProps, getFieldError, getFieldValue } = this.props.form;
        let {
            loading,
            bottomBanner,
            bottomBannerLink,
            topBanner,
            topBannerLink,
            questionList,
            submitLoading,
            answersObj,
            expired,
            hadAnswer,
            countryCodeList,
            areaCode,
            phone,
            verify,
            countdown,
            hassend,
            showLeaveDialog,
            hasSubmit,
            layerUrl,
            questionInfo,
            hadAnswerTips,
            tipsTimerCount,
            pagingDisplay,
            checked,
            isShowRepeatBuy,
            weChatUrl,
        } = this.state;
        let { activityState, buttonText, showConfigExt } = questionInfo;
        try {
            showConfigExt = JSON.parse(showConfigExt);
        } catch (error) {}
        const isNewTemplate = this.state.productInfo?.activity?.channelDeliveryVersion?.templateSource === 1 && this.state.productInfo?.activity?.channelDeliveryVersion?.templateConfigId;
         // 有易聊数据嵌入易聊内容
        if (!!this.state.productInfo?.activity?.channelDeliveryVersion?.easyChatRobotUrl) {
            return (
                <EasyChatIframe url={`${this.state.productInfo.activity.channelDeliveryVersion.easyChatRobotUrl}&x_field_1=${x_field_1}`}/>
            )
        }
        // 当新模版时，渲染新模版，不加载旧模版
        if (isNewTemplate)
            return (
                <>
                    <SchemaRender productInfo={this.state.productInfo} initProductInfo={this.initData} {...this.props} />
                    <Modal
                        visible={hadAnswerTips}
                        transparent
                        maskClosable={false}
                        onClose={this.handleHadAnswerTipsHide}
                        title=""
                        footer={[
                            {
                                text: '取消',
                                onPress: () => {
                                    this.handleHadAnswerTipsHide();
                                },
                            },
                            {
                                text: '立即跳转',
                                onPress: () => {
                                    this.handleHadAnswerTipsHide();
                                    this.handleGointoSuccessPage();
                                },
                            },
                        ]}
                    >
                        <div className="questionnaire-hadAnswer-tips">
                            <h4>您已提交过该表单</h4>
                            <p>
                                <span>{tipsTimerCount}s</span> 后自动前往下一页
                            </p>
                        </div>
                    </Modal>
                </>
            );
        return (
            <PageLoading loading={loading}>
                {
                    // 已过期
                    expired ? (
                        <SoldOut
                            text="页面已失效"
                            title="我的"
                            link="/mypage"
                            optionImg="https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202108/10/5590a_20210810160925.png"
                        />
                    ) : (
                        <>
                            {pagingDisplay == 2 && !!window['browser'].mobile ? (
                                <CommitForm
                                    list={questionList}
                                    showConfigExt={showConfigExt}
                                    onClick={val => {
                                        !!hadAnswer ? this.handleGointoSuccessPage() : this.handleSave(val);
                                    }}
                                    //   goSuccess={this.handleGointoSuccessPage}
                                    getQuestionAnswers={this.getQuestionAnswers}
                                />
                            ) : (
                                <>
                                    {topBanner && (
                                        <div className="questionnaire-banner">
                                            <GdImage
                                                src={topBanner}
                                                alt=""
                                                onClick={() => {
                                                    if (topBannerLink) window.location.href = topBannerLink;
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div
                                        className="questionnaire-cont"
                                        style={{
                                            flexDirection:
                                                !!showConfigExt && showConfigExt.mobilePosition == 1 ? `column-reverse` : `column`,
                                        }}
                                    >
                                        <div className="questionnaire-login">
                                            {
                                                // 手机号填写控制
                                                !accessToken || needPhoneBind ? (
                                                    <Fragment>
                                                        <InputItem
                                                            className="login-phone"
                                                            type="number"
                                                            value={phone}
                                                            placeholder="请输入手机号"
                                                            clear
                                                            maxLength={areaCode[0] === '86' ? 11 : 20}
                                                            onChange={value =>
                                                                this.setState({
                                                                    phone: value,
                                                                })
                                                            }
                                                            error={phone && !isAreaPhone(phone, areaCode[0])}
                                                            onErrorClick={() =>
                                                                Toast.info(`请输入${areaCode[0] === '86' ? '11位' : '5位以上'}数字`)
                                                            }
                                                        >
                                                            手机
                                                            <Picker
                                                                title="选择区号"
                                                                extra="请选择(可选)"
                                                                data={countryCodeList}
                                                                value={areaCode}
                                                                cols={1}
                                                                onOk={value =>
                                                                    this.setState({
                                                                        areaCode: value,
                                                                    })
                                                                }
                                                            >
                                                                <div className="login-areacode">
                                                                    +{areaCode[0]}
                                                                    <i className="iconfont icondown"></i>
                                                                </div>
                                                            </Picker>
                                                        </InputItem>
                                                        <InputItem
                                                            type="number"
                                                            value={verify}
                                                            placeholder="请输入验证码"
                                                            clear
                                                            maxLength={6}
                                                            onChange={value =>
                                                                this.setState({
                                                                    verify: value,
                                                                })
                                                            }
                                                            error={verify && !isVerifyCode(verify)}
                                                            onErrorClick={() => Toast.info('请输入6位数字')}
                                                            labelNumber={0}
                                                            extra={
                                                                <div
                                                                    className={
                                                                        !countdown ? 'login-verifycode' : 'login-verifycode disabled'
                                                                    }
                                                                    onClick={this.handleSendVerifyCode}
                                                                >
                                                                    {!countdown
                                                                        ? hassend
                                                                            ? '重新获取'
                                                                            : '获取验证码'
                                                                        : `${countdown}秒后重发`}
                                                                </div>
                                                            }
                                                        >
                                                            验证码
                                                        </InputItem>
                                                    </Fragment>
                                                ) : (
                                                    <div className="questionnaire-item">
                                                        <div className="questionnaire-item-q">手机： {userInfo.Phone}</div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <div className="questionnaire-list">
                                            {questionList.map((item, index) => {
                                                let defaultAnswer;
                                                if (item.defaultAnswer) {
                                                    try {
                                                        defaultAnswer = JSON.parse(item.defaultAnswer);
                                                    } catch (error) {
                                                        defaultAnswer = item.defaultAnswer;
                                                    }
                                                }
                                                let initialValue = answersObj[item.name] || defaultAnswer;
                                                // 未做过 && 有默认值 && 院校专业默认值不完整完整
                                                if (
                                                    !hadAnswer &&
                                                    defaultAnswer &&
                                                    ((item.bizTypeName === '学校' && !defaultAnswer.school) ||
                                                        (item.bizTypeName === '学院' &&
                                                            (!defaultAnswer.school || !defaultAnswer.college)) ||
                                                        (item.bizTypeName === '专业' &&
                                                            (!defaultAnswer.school || !defaultAnswer.college || !defaultAnswer.major)))
                                                ) {
                                                    initialValue = null;
                                                }
                                                return (
                                                    <QuestionnaireItem
                                                        key={index}
                                                        name={item.name}
                                                        required={!!item.requiredFlag}
                                                        disabled={hadAnswer}
                                                        question={item}
                                                        defaultAnswer={defaultAnswer}
                                                        {...getFieldProps(item.name, {
                                                            initialValue,
                                                            rules: getVerifyRoles(item),
                                                        })}
                                                        error={getFieldError(item.name)}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <div className="questionnaire-btns">
                                        {activityState == '待开始' ? (
                                            <Button className="my-button" type="primary" disabled={true}>
                                                {activityState}
                                            </Button>
                                        ) : (
                                            <>
                                                {!hadAnswer && (
                                                    <ProtocolCheck
                                                        onRef={e => {
                                                            this.checkEle = e;
                                                        }}
                                                        checked={checked}
                                                        onChange={newCheck => this.setState({ checked: newCheck })}
                                                    />
                                                )}
                                                <Button
                                                    className="my-button"
                                                    type="primary"
                                                    disabled={submitLoading}
                                                    loading={submitLoading}
                                                    onClick={hadAnswer ? this.handleGointoSuccessPage : this.handleSave}
                                                >
                                                    <span>{hadAnswer ? '您已提交，点击查看更多' : !!buttonText ? buttonText : '提交'}</span>
                                                </Button>
                                            </>
                                        )}
                                        {/* <p className="questionnaire-btns-tips">*提交即代表您同意相关数据收集</p> */}
                                    </div>
                                    {bottomBanner && (
                                        <div className="questionnaire-banner">
                                            <GdImage
                                                src={bottomBanner}
                                                alt=""
                                                onClick={() => {
                                                    if (bottomBannerLink) window.location.href = bottomBannerLink;
                                                }}
                                            />
                                        </div>
                                    )}
                                </>
                            )}

                            <CopyRight rightBottomNone={true} />
                        </>
                    )
                }

                {showLeaveDialog && !hasSubmit && (
                    <LeaveDialog
                        imageSrc={layerUrl || defaultLayerUrl}
                        errorText=""
                        okText="继续填写"
                        statusChange={this.dialogStatusChange}
                    />
                )}

                <Modal
                    visible={hadAnswerTips}
                    transparent
                    maskClosable={false}
                    onClose={this.handleHadAnswerTipsHide}
                    title=""
                    footer={[
                        {
                            text: '取消',
                            onPress: () => {
                                this.handleHadAnswerTipsHide();
                            },
                        },
                        {
                            text: '立即跳转',
                            onPress: () => {
                                this.handleHadAnswerTipsHide();
                                this.handleGointoSuccessPage();
                            },
                        },
                    ]}
                >
                    <div className="questionnaire-hadAnswer-tips">
                        <h4>您已提交过该表单</h4>
                        <p>
                            <span>{tipsTimerCount}s</span> 后自动前往下一页
                        </p>
                    </div>
                </Modal>
                {isShowRepeatBuy ? (
                    <div>
                        <div className="repeat-buy-mask"></div>
                        <div className="repeat-buy-box">
                            <div className="repeat-buy">
                                <GdImage src={weChatUrl} className="wechat-url" />
                                <div className="close-icon" onClick={this.closeRepeat}></div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </PageLoading>
        );
    }
}

export default withRouter(connect(createForm()(Questionnaire)));
